export default function AuthSourceService({ baseUrl, http, withIosCookies }) {
  const PATH_SIGN_IN = '/profile';
  const PATH_LOG_OUT = '/sessionLogout';

  return {
    checkAuthenticated,
    logOut,
  };

  function checkAuthenticated(headers) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_SIGN_IN}`,
      headers,
      withIosCookies,
    });
  }

  function logOut() {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_LOG_OUT}`,
      withIosCookies,
    });
  }
}
